import React from "react";
import { Loader } from "./Loader";
import { LoaderIcon } from "library";

export const PageLoader = (props) => (
  <Loader {...props}>
    <LoaderIcon />
  </Loader>
);
